import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const AdminForgotPasswordPage = () => {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('أدخل بريدك الإلكتروني'); return; }
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email: email.trim().toLowerCase(), portal: 'admin' });
      setSent(true);
    } catch {
      setError('حدث خطأ، حاول مجدداً');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-blue-800 mb-2">🚌 سافر</h1>
          <p className="text-gray-500 text-sm">استعادة كلمة المرور — بوابة الشركات</p>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="text-5xl mb-4">📧</div>
            <h2 className="text-lg font-bold text-gray-800 mb-2">تحقق من بريدك الإلكتروني</h2>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              إذا كان البريد <span className="font-semibold text-gray-700">{email}</span> مسجلاً،
              ستصلك رسالة تحتوي على رابط إعادة التعيين خلال دقائق.
              تحقق من مجلد Spam إذا لم تجدها.
            </p>
            <Link to="/admin/login" className="block w-full text-center bg-blue-700 hover:bg-blue-800 text-white font-semibold py-3 rounded-lg transition">
              العودة لتسجيل الدخول
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-gray-600 leading-relaxed">
              أدخل بريدك الإلكتروني المسجّل وسنرسل لك رابط إعادة تعيين كلمة المرور.
            </p>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">البريد الإلكتروني</label>
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                placeholder="admin@company.com"
                dir="ltr"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {error && <p className="text-red-600 text-sm font-semibold">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-700 hover:bg-blue-800 disabled:bg-blue-400 text-white font-semibold py-3 rounded-lg transition"
            >
              {loading ? 'جاري الإرسال...' : 'إرسال رابط الاستعادة'}
            </button>

            <Link to="/admin/login" className="block text-center text-sm text-gray-500 hover:text-blue-700 font-medium transition">
              ← العودة لتسجيل الدخول
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;
